import * as Yup from 'yup'
import { CALCULATION_TYPE } from 'domains/payment-method/constants'

const paymentMethodUpdateRateFormSchema = Yup.object().shape(
  {
    absolute_value_customer: Yup.number()
      .when('calculation_type', {
        is   : (value) => value === CALCULATION_TYPE.ABSOLUTE,
        then : Yup.number()
          .min(0)
          .required(
            'Absolute Value Customer Required'
          ),
        otherwise: Yup.number()
      }),
    absolute_value_actual: Yup.number()
      .when('calculation_type', {
        is   : (value) => value === CALCULATION_TYPE.ABSOLUTE,
        then : Yup.number()
          .min(0)
          .required(
            'Absolute Value Customer Required'
          ),
        otherwise: Yup.number()
      }),
    percentage_value_customer: Yup.number()
      .when('calculation_type', {
        is   : (value) => value === CALCULATION_TYPE.PERCENTAGE,
        then : Yup.number()
          .min(0)
          .max(100)
          .required(
            'Percentage Value Customer Required'
          ),
        otherwise: Yup.number()
      }),
    percentage_value_actual: Yup.number()
      .when('calculation_type', {
        is   : (value) => value === CALCULATION_TYPE.PERCENTAGE,
        then : Yup.number()
          .min(0)
          .max(100)
          .required(
            'Percentage Value Customer Required'
          ),
        otherwise: Yup.number()
      })
  }
)

export default paymentMethodUpdateRateFormSchema
